module.exports = __webpack_public_path__ + "img/yuanquan_sel.6e7e5e9b.png";